import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { configureClient } from './api/client';
import App from './modules/app/App';
import registerServiceWorker from './registerServiceWorker';
import 'normalize.css';

configureClient();

ReactDOM.render(
    <App />,
    document.getElementById('root') as HTMLElement
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx